import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { format } from "date-fns";

interface IncidentDateStepProps {
  incidentDateTime: string;
  onDateChange: (date: string) => void;
  onBack: () => void;
  onNext: () => void;
}

export const IncidentDateStep = ({
  incidentDateTime,
  onDateChange,
  onBack,
  onNext,
}: IncidentDateStepProps) => {
  const formatDateTime = (dateTime: string) => {
    if (!dateTime) return "";
    try {
      return format(new Date(dateTime), "PPpp");
    } catch {
      return dateTime;
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-primary-dark mb-4">
        When did this incident occur?
      </h3>
      <div className="space-y-2">
        <Input
          type="datetime-local"
          value={incidentDateTime}
          onChange={(e) => onDateChange(e.target.value)}
          className="max-w-xs bg-white border-gray-200 focus:border-primary focus:ring-primary"
        />
        {incidentDateTime && (
          <p className="text-sm text-gray-600">
            {formatDateTime(incidentDateTime)}
          </p>
        )}
      </div>
      <div className="flex justify-between pt-4">
        <Button
          variant="outline"
          onClick={onBack}
          className="flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" /> Back
        </Button>
        <Button
          onClick={onNext}
          disabled={!incidentDateTime}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};